/*
 feeds api
*/

import axios from '../axios/axios';

export function getThreadsApi(params) {
  return axios.post('/threads/get', params);
}

export function getThreadExtendedApi(params) {
  return axios.post('/thread/getthreadextended', params);
}

export function getApiLogApi(params) {
  return axios.post('/users/getApiLog', params);
}

export function getUserThreadsApi(params) {
  return axios.post('/users/getuserthreads', params);
}

export function getAdditionalInfoApi(params) {
  return axios.post('/thread/additional_info', params);
}

export function getThreadsFilesApi(params) {
  return axios.post('/thread/getfiles', params);
}

export function getThreadUsersApi(params) {
  return axios.post('/thread/getthreadusers', params);
}

export function setThreadUsersApi(params) {
  return axios.post('/thread/setuserstothread', params);
}

export function threadsSaveApi(params) {
  return axios.post('/thread/save', params);
}

export function getSourcesApi(params) {
  return axios.post('/thread/allmembers', params);
}

export function deleteSourcesApi(params) {
  return axios.post('/thread/settings_sources_profiles_delete', params);
}

export function addSourcesApi(params) {
  return axios.post('/thread/settings_sources_profiles_add_list', params);
}

export function addRecommendationApi(params) {
  return axios.post('/thread/recomendationadd', params);
}

export function getKeyWordsApi(params) {
  return axios.post('/thread/settings_sources_keywords_get_advanced', params);
}

export function getSettingsFiltersApi(params) {
  return axios.post('/thread/settings_filters_get', params);
}

export function getReferencesNetworksApi() {
  return axios.post('/references/networks');
}

export function threadGetPeriodsApi(params) {
  return axios.post('/thread/settings_periods_get', params);
}

export function threadSetPeriodsApi(params) {
  return axios.post('/thread/settings_periods', params);
}

export function threadSetSourcesKeywordsAdvanced(params) {
  return axios.post('/thread/settings_sources_keywords_advanced', params);
}

export function threadSetFiltersAdvanced(params) {
  return axios.post('/thread/settings_filters', params);
}

export function threadUnpublishApi(params) {
  return axios.post('thread/unpublish', params);
}

export function threadPublishApi(params) {
  return axios.post('thread/publish', params);
}

export function threadDeleteApi(params) {
  return axios.post('thread/delete', params);
}

export function getStopSourcesApi(params) {
  return axios.post('/thread/liststopsource', params);
}

export function deleteStopSourceApi(params) {
  return axios.post('/thread/removestopsource', params);
}

export function addStopSourcesApi(params) {
  return axios.post('/thread/addstopsource', params);
}

export function getMetaSourcesApi(params) {
  return axios.post('/thread/getMetaItems', params);
}

export function getSourcesByNetApi(params) {
  return axios.post('/thread/getSourcesByNet', params);
}

export function addMetaItemItemApi(params) {
  return axios.post('/thread/addMetaItemItem', params);
}

export function saveMetaItemApi(params) {
  return axios.post('/thread/saveMetaItem', params);
}

export function deleteMetaItemApi(params) {
  return axios.post('/thread/removeMetaItem', params);
}

export function deleteMetaItemItemApi(params) {
  return axios.post('/thread/removeMetaItemItem', params);
}

export function getThreadAtTendanceApi(params) {
  return axios.post('/stats/getthreadattendance', params);
}

export function getStatsParamsApi(params) {
  return axios.post('/thread/getStatsParams', params);
}

export function setStatsParamsApi(params) {
  return axios.post('/thread/setStatsParams', params);
}

export function getReportApi(params) {
  console.log("DDDDD", params)
  return axios.post(params + '&ajax=1');
}